const MarketStorage = {
    availableMarketHeaders: ['name'],
    activeMarketHeaders: ['name', 'defaultSpend'],
    stationAndCablesHeaders: [
        'code',
        'alias',
        'network',
        'name',
        'networkType',
        'format',
        'frequency',
        'stationContact',
    ],
};

export const marketTypes = [
    { id: 1, name: 'TV' },
    { id: 2, name: 'Radio' },
];

export const defaultGroupNameFormState = {
    type: null,
    marketGroupDetails: null,
}

export const MarketScope = {
    AGENCY: 1,
    CLIENT: 2,
};

export const marketScopeSwitchOptions = [
  { id: MarketScope.AGENCY, label: 'Agency' },
  { id: MarketScope.CLIENT, label: 'Client' },
];

export const defaultMarketGroup = {
    id: 0,
    name: 'Default',
    active: null,
};

// Superadmin Panel
export const SuperAdminMarketStorage = {
    formFields: [
        {
            label: 'Market Name',
            name: 'marketName',
            type: 'text',
            placeholder: "Enter a name for this market",
            isRequired: true,
            maxLength: '50',
        },
        {
            label: 'System Alias',
            name: 'systemAlias',
            type: 'text',
            isRequired: true,
            placeholder: "Enter an alias for this market",
            maxLength: '50',
        },
        {
            label: 'Type',
            name: 'type',
            type: 'select',
            list: marketTypes,
            isRequired: false,
            width: '100%',
            noSearch: true,
        },
    ],
    marketTypes,
}


export default MarketStorage;
